/**
 * Are we in the public read-only demo (/demo/*)? Derived from the URL so any
 * component can ask without a provider. Used to hide setup/connect/customize
 * affordances (locked cards, "Connect a platform" CTAs, the Exec editor) that
 * make no sense in a no-login showcase.
 */
import { useLocation } from "react-router-dom";

export function useDemoMode(): boolean {
  return useLocation().pathname.startsWith("/demo");
}
